import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import TopBar from "@/components/TopBar";
import CopilotPanel from "@/components/CopilotPanel";

export default function AppLayout() {
    const [copilotOpen, setCopilotOpen] = useState(false);
    const [context, setContext] = useState({
        company: "Meridian Retail Holdings",
        brand: "All Brands",
        country: "India",
        period: "Last 30 Days",
        channel: "All Channels",
    });

    return (
        <div className="flex h-screen w-full bg-background text-foreground" data-testid="app-shell">
            <Sidebar />
            <div className="flex min-w-0 flex-1 flex-col">
                <TopBar
                    context={context}
                    setContext={setContext}
                    onOpenCopilot={() => setCopilotOpen(true)}
                />
                <main className="flex-1 overflow-y-auto">
                    <Outlet context={{ context, openCopilot: () => setCopilotOpen(true) }} />
                </main>
            </div>
            <CopilotPanel open={copilotOpen} onClose={() => setCopilotOpen(false)} />
        </div>
    );
}
